import { Container, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { ProductSummarySlim } from "./../ProductInfo/ProductSummarySlim";
import { TrackList } from "./../Projects/TrackList";
import { ProductStatusAll } from "./../ProductInfo/ProductStatusAll";
import { ErrorPage } from "./../Pages/ErrorPage";
import { FileErrors } from "./../Projects/FileErrors";
import { useProjects } from "./../Behaviors/projects";
import { isValidGuid } from "./../validation/validation";
import { getFileErrors } from "./../validation/fileValidator";
import { PrintWindowButton } from "./../Buttons/Buttons";

const formatDate = function (dt: Date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    //const dt = new Date();
    const year = dt.getUTCFullYear();
    const month = monthNames[dt.getUTCMonth()].padStart(2, "0");
    const day = String(dt.getUTCDate()).padStart(2, "0");
    const hours = String(dt.getUTCHours()).padStart(2, "0");
    const minutes = String(dt.getUTCMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
    return formattedDate;
};

export const DiscrepancyReportPage = () => {
    const params = useParams<{ p: string }>();
    const projectId = params.p;
    const { project } = useProjects(projectId!);

    if (!project) {
        return null; // still loading
    }

    if (!isValidGuid(projectId) || (project && Object.keys(project).length === 0)) { // {} = empty project means not found!
        const errMsg = "The requested project does not exist, or you are not authorized to view it!";
        return (<ErrorPage error={errMsg} />);
    }

    const lastUpdated = formatDate(new Date(project.lastModified!));

    const fileErrors = getFileErrors(project!);
    const hasFileErrors = (fileErrors?.length ?? 0) > 0;
    return (
        <Container className="h-100" fluid>
            <br /><PrintWindowButton />
            <h4>Discrepancy Report</h4>
            <hr />
            <Row className="w-100">
                <Col className="w-40" md={5}>
                    <h4>Product Info</h4>
                    <div className="outline" >
                        <ProductSummarySlim projectId={params.p} />
                        <ProductStatusAll projectId={params.p} />
                    </div>
                    <br />
                    {hasFileErrors ?
                        <FileErrors projectId={params.p} />
                        : null
                    }
                    <br />
                    <h6 className="mt-3"> {lastUpdated} UTC</h6>
                </Col>
                <Col className="w-60" md={7}>
                    <h4>Track List</h4>
                    <div className="outline" >
                        <TrackList projectId={params.p} />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
